export default {
    doctor: [],
    sales: ['Sales_Case_Leader_Board'],
    manager: ['Manager_Key_Message', 'Manager_Headline'],
};
